import { computed } from "vue";
import { useState } from "#app";
export class AlertMessage {
  message;
  color;
  icon;
  location;
  onClick;
}
export function useAlertService() {
  const alertMessage = useState("alertMessage", () => null);
  const setAlertMessage = (message) => {
    alertMessage.value = message;
  };
  const setAlertMessageDelayed = (message, delayMilliseconds) => {
    setTimeout(() => {
      setAlertMessage(message);
    }, delayMilliseconds);
  };
  const alertActive = computed({
    get() {
      return !!alertMessage.value;
    },
    set(value) {
      if (value === true) {
        alertMessage.value = alertMessage.value ?? "";
      } else {
        alertMessage.value = null;
      }
    }
  });
  return {
    setAlertMessageDelayed,
    setAlertMessage,
    alertActive,
    alertMessage
  };
}
